import React, { useEffect, useState } from 'react'
import Header from '../components/common/Header'
import Hero from '../components/hero/Hero'
import Awosomeservices from '../components/services/Awosomeservices'
import HeroNumbers from '../components/hero/HeroNumbers'
import TechnologiesWork from '../components/Technologies/TechnologiesWork'
import OurPartners from '../components/partners/OurPartners'
import DownloadApp from '../components/partners/DownloadApp'
// import QualityWork from '../components/QualityWork'
import Testimonials from '../components/testimonials/testimonials'
import ContactForm from '../components/contact-form/ContactForm';
import Footer from '../components/common/Footer';
import Whatsapp from '../components/services/Whatsapp';
import GetAQuote from '../components/modals/TechnologyWorkModal'
function Home() {
    const [openModal, setOpenModal] = useState(false);
    const [from, setFrom] = useState('');
    const solutions = {
        heading: 'Select the Ideal Solutions for Your Requirements',
        p: 'Noorisys Offers Flexible App Development Solutions and Methodologies',
        image: false,
        fixHeight: 'fix-height',
        bootstrapClass: 'col-xl-3 col-lg-4 col-sm-6 mt30',
        solutions: [
            {
                heading: 'Custom Mobile Application',
                p: `Get a Mobile App that matches Your Vision with the Help of Our Expert Team at a <span style=" color:#AC2121; font-weight:900;"> Fixed Cost</span>.`,
                img: "images/svg/prototype.svg",
                class: 'reebga',
                button: 'Calculate your cost',
                type: "modal",
            },
            {
                heading: 'Ready-to-Go Solution',
                p: `Save time and money using our<span style=" color:#107D10; font-weight:900;" > White Label </span> solutions, available with<span style=" color:#107D10; font-weight:900;"> source code </span> or on a <span style=" color:#107D10; font-weight:900;"> subscription basis.</span> <br />`,
                img: "images/svg/prototype.svg",
                class: 'reebgl',
                button: 'Checkout ready products',
                type: "link",
                // url: "https://noorisys.com/our-products"
                url: "#work"
            },
            {
                heading: 'Hire a Dedicated Team',
                p: ` Select resources from our highly qualified team of <span style=" color:#152191; font-weight:900;">Flutter, React Native, Kotlin, Swift, UI/UX design </span> etc.`,
                img: "images/svg/prototype.svg",
                class: 'reebgc',
                button: 'Check rate card',
                type: "modal"
            },
            {
                heading: 'Explore Additional Services',
                // p: ` Our skilled <span style=" color:#960973; font-weight:900;"> web </span> and <span style=" color:#960973; font-weight:900;"> backend developers </span> are proficient in technologies like <span style=" color:#960973; font-weight:900;">Node.js, React.js, PHP </span> etc. `,
                p: ` Our skilled <span style=" color:#960973; font-weight:900;"> developers </span> are proficient in technologies like <span style=" color:#960973; font-weight:900;">Node.js, React.js, PHP </span> etc. `,
                img: "images/svg/prototype.svg",
                class: 'reebgd',
                button: 'Explore our services',
                type: "link",
                url: "#technologies"
            },
        ]
    }
    const readySolutions = {
        heading: 'Ready-To-Go Solutions',
        p: 'Select from our White Label solutions to free yourself from the worries of development and save your precious time.',
        image: true,
        fixHeight: 'fixheight',
        bootstrapClass: 'col-xxl-3 col-xl-4 col-lg-4 col-sm-6 mt30',
        solutions: [
            {
                heading: 'School Management System',
                p: `It has been designed with parents in mind, providing them with timely information about their child's school activities  It has a diverse user base, including Students, Parents, Teachers, Accountants, Librarians, Receptionists and Administrators.`,
                img: 'images/products/dp-product-05.webp',
                class: 'reebgc',
                link: 'school-management'
            },
            {
                heading: 'Doctor Appointment with Teleconsultation',
                p: 'This app is used for scheduling doctor appointments and purchasing medicines seamlessly. It serves diverse users, including patients, doctors, pharmacies, and delivery personnel efficiently and effectively.',
                img: 'images/products/dp-product-01.webp',
                class: 'reebgl',
                link: 'doctor-appointment'
            },
            {
                heading: 'Service Provider Marketplace ',
                p: 'This app seamlessly connects users and service providers. Users have features like location-based service provider searches, detailed provider profiles, scheduling and managing bookings, messaging and a review system. ',
                img: 'images/products/dp-product-02.webp',
                class: 'reebga',
                link: 'service-marketplace'
            },
            {
                heading: 'Pharmacy Ordering App',
                p: 'Our Pharmacy app offers easy profile management, ordering medicine, and wallet payments. A Delivery Man app and an admin panel have user management, operations, and communications functionalities.  ',
                img: 'images/products/dp-product-11.webp',
                class: 'reebgc',
                link: 'pharmacy-ordering'
            },
            {
                heading: 'Food Delivery App',
                p: 'Our app is ideal for all types of restaurants, offering essential features such as multi-language support, precise coverage area mapping, robust order management to streamline operations, and secure payment gateways.',
                img: 'images/products/dp-product-03.webp',
                class: 'reebgm',
                link: 'food-delivery'
            },
            {
                heading: 'Digital Business Card',
                p: '  This smart visiting card uses Near Field Communication (NFC) technology. It allows users to easily share their contact details with others by tapping the card on compatible mobile devices.    ',
                img: 'images/products/dp-product-10.webp',
                class: 'reebgk',
                link: 'digital-business-card',
            },
            {
                heading: 'Transport Management System',
                p: ' This is a transport management system where users can search and book available freight based on their preferred mode of transport i.e. ocean consolidation or air freight. ',
                img: 'images/products/dp-product-13.webp',
                class: 'reebgk',
                link: 'transport-management-system'
            },
            {
                heading: 'Helpdesk Ticketing Platform',
                p: 'This is a comprehensive platform for handling customer queries, managing support tickets, and facilitating efficient communication and collaboration between customers and support agents.  ',
                img: 'images/products/dp-product-12.webp',
                class: 'reebgj',
                link: 'helpdesk-ticketing-platform'
            },
            {
                heading: 'Learning Management System',
                p: ' It unites students and teachers to facilitate knowledge sharing via a structured course framework. Instructors have the flexibility to develop an unlimited number of courses, video lessons and instructional materials  ',
                img: 'images/products/dp-product-06.webp',
                class: 'reebgh',
                link: 'learning-management'
            },
            {
                heading: 'Electronic Medical Record ',
                p: ' It is a comprehensive Electronic Medical Records (EMR) system designed for healthcare management. The system caters to various user roles, including Doctors, Doctor Assistants, Nurses, Midwives, Patients and Admins.',
                img: 'images/products/dp-product-09.webp',
                class: 'reebgi',
                link: 'mugenzi-emr'
            },
            {
                heading: 'Social Media Platform',
                p: ' This is an event social media app that bridges real-world events and the convenience of social media. Users can explore nearby events, create their own and engage with the community through likes, comments and event sharing.',
                img: 'images/products/dp-product-04.webp',
                class: 'reebgd',
                link: 'social-platform'
            },
            {
                heading: 'Taxi App',
                p: 'This application allows users to book rides in advance or instantly and track driver location with real-time chat. Users will pay the drivers outside the system. Drivers can manage their availability, accept/reject rides and subscription charges.',
                img: 'images/products/dp-product-14.webp',
                class: 'reebgn',
                link: 'transport-management-system'
            },
            {
                heading: 'Fitness App',
                p: 'Our Fitness app is designed to support health and wellness journey. With an extensive library of exercises  users can easily find workouts that suit their goals. It also offers personalized diet plans, empowering users to make healthier food choices and achieve nutritional goals.',
                img: 'images/products/dp-product-15.webp',
                class: 'reebgc',
                link: 'fitness-app'
            },
        ]
    }
    const toggle = () => {
        setOpenModal(!openModal)
    }
    useEffect(() => {
        // Set interval to open modal every 90 seconds
        const intervalId = setInterval(() => {
            setOpenModal(true)
        }, 60000);

        // Clear the interval on component unmount
        return () => clearInterval(intervalId);
    }, [toggle]);
    return (
        <div className="App">
            <GetAQuote openModal={openModal} toggle={toggle} from={from} buttonName={'Get A Free Quote'} interval={true} />
            <Header />
            <Hero setOpenModal={setOpenModal} setFrom={setFrom} />
            <Awosomeservices solutions={solutions} id={'service'} />
            <HeroNumbers />
            <Awosomeservices solutions={readySolutions} id={'work'} paddingClass={'sec-top-pad'} />
            <TechnologiesWork id={'technologies'} />
            <Whatsapp />
            <Testimonials />
            {/* <DownloadApp /> */}
            <div className='sec-top-pad'>
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-lg-6">
                            <div className="sec-heading text-center">
                                <h2 className='text-center'>Work Samples</h2>
                                <p className='text-center mt20'>Take a look at some of our finest custom apps, demonstrating our capability to create innovative and bespoke solutions that cater to the specific requirements of our diverse clientele.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <DownloadApp
                    heading="Healthcare Apps"
                    // subheading="Download Our App"
                    // text="Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis."
                    androidLink="https://play.google.com/store"
                    iosLink="https://www.apple.com/ios/app-store/"
                    imageUrl="images/others/lpc.webp"
                    imageOnLeft={true}
                    buttonName={'Doctor Appointment'}
                    listItem={[
                        { heading: 'Tele-Consultation', para: 'Remotely connect with healthcare doctors.' },
                        { heading: 'Gyno Care', para: `Specialized care for women's health needs.` },
                        { heading: 'Nursing Platform', para: 'Manage schedules and patient info efficiently.' },
                        { heading: 'Pharmacy Ordering', para: 'Order medications and health products online.' },
                        { heading: 'EMR', para: 'Securely access and manage patient medical records.' }]}
                />
                <DownloadApp
                    heading="eCommerce"
                    // subheading="Download Our App"
                    // text="Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis."
                    androidLink="https://play.google.com/store"
                    iosLink="https://www.apple.com/ios/app-store/"
                    imageUrl="images/others/annachi.webp"
                    imageOnLeft={false}
                    buttonName={'Doctor Appointment'}
                    listItem={[
                        { heading: 'Online Grocery', para: ' Order groceries online with timely delivery.' },
                        { heading: 'Online Bookshop', para: 'Browse & purchase books from various genres.' },
                        { heading: 'Sri Lanka’s Largest eCommerce Platform', para: 'Shop online efficiently.' },
                        { heading: 'Food Delivery', para: ' Order meals from your favorite restaurants.' },
                        { heading: 'Freelancing', para: 'Connect with freelancers for various services.' },
                        { heading: 'Apparel', para: 'Shop the latest fashion trends and accessories.' },
                        { heading: 'Real Estate', para: 'Explore listings and connect with real estate agents.' }
                    ]}
                />
                <DownloadApp
                    heading="Tourism"
                    // subheading="Download Our App"
                    // text="Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis."
                    androidLink="https://play.google.com/store"
                    iosLink="https://www.apple.com/ios/app-store/"
                    imageUrl="images/others/umrah.webp"
                    imageOnLeft={true}
                    buttonName={'Doctor Appointment'}
                    listItem={[
                        { heading: 'Flight Booking', para: 'Easily book flights with competitive pricing.' },
                        { heading: 'Train Booking', para: 'Reserve train tickets for various routes.' },
                        { heading: 'Hotel Booking', para: 'Find and book accommodations of all types.' },
                        { heading: 'Holiday Packages', para: 'Choose from curated holiday itineraries.' },
                        { heading: 'AI-Based Visa Processing', para: 'Streamlined visa application process.' },
                        { heading: 'Hajj Umrah Tours', para: 'Travel arrangements for pilgrims.' }
                    ]}
                />
                <DownloadApp
                    heading="Fintech"
                    // subheading="Download Our App"
                    // text="Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis."
                    androidLink="https://play.google.com/store"
                    iosLink="https://www.apple.com/ios/app-store/"
                    imageUrl="images/others/sesapay.webp"
                    imageOnLeft={false}
                    buttonName={'Doctor Appointment'}
                    listItem={[
                        { heading: 'Payment Wallet', para: 'Securely store and manage digital payments.' },
                        { heading: 'Online Banking', para: 'Convenient access to banking services online.' },
                        { heading: 'Scholarship Distribution', para: 'Efficiently manage scholarship funds.' },
                        { heading: 'Mobile Money', para: 'Perform financial transactions via mobile devices.' }]}
                />
            </div>
            <OurPartners />

            {/* <QualityWork /> */}
            <ContactForm />
            <Footer />
        </div>
    )
}

export default Home